import { Box, Text } from "@chakra-ui/layout";
import { CircularProgress } from "@chakra-ui/progress";

export default function CourseName({ title, loading }) {
    return (
        <Box
            w='100%'
            d='flex'
            flexDir='column'
            mb='1.5rem'
        >
            <Text
                fontSize='15px'
                color='#222222'
                fontWeight='800'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                mb='1rem'
            >
                COURSE TITLE
            </Text>


            <Box
                w='100%'
                d='flex'
                mb='1.5rem'
                border='1px solid rgba(0, 0, 0, 0.1)'
                borderRadius='10px'
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                py='1.5rem'
                pl='1rem'
                justifyContent='flex-start'
                alignItems='center'
                bg='#ffffff'
            >
                {
                    loading ? <Box width='100%' d='flex' justifyContent='center' alignItems='center' my='0.5rem'>
                        <CircularProgress isIndeterminate color='#3e59de' size='50px' />
                    </Box> :
                        <Text fontSize='25px' fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }} textTransform='capitalize'>{title}</Text>
                }
            </Box>
        </Box>
    )
}